import * as React from 'react';

function SvgLayerBackward(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8.354 15.854a.5.5 0 01-.708 0l-3-3a.5.5 0 010-.708l1-1a.5.5 0 01.708 0l.646.647V4H1a1 1 0 01-1-1V1a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H9v7.793l.646-.647a.5.5 0 01.708 0l1 1a.5.5 0 010 .708l-3 3z' />
			<path d='M1 9a1 1 0 01-1-1V6a1 1 0 011-1h4.5a.5.5 0 010 1H1v2h4.5a.5.5 0 010 1H1zm9.5 0a.5.5 0 010-1H15V6h-4.5a.5.5 0 010-1H15a1 1 0 011 1v2a1 1 0 01-1 1h-4.5z' />
		</svg>
	);
}

export default SvgLayerBackward;
